import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGardeningSprinkleBottle = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}.cls-2{fill:#231f20;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "gardening-sprinkle-bottle" }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M11.769,3.75h4.5l2.25,6V21a1.5,1.5,0,0,1-1.5,1.5h-6a1.5,1.5,0,0,1-1.5-1.5V9.75Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M16.269,3.75h.75a6,6,0,0,1,6,6V12"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 8.019,
			y1: 5.25,
			x2: 11.206,
			y2: 5.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 14.018,
			y1: 3.75,
			x2: 14.018,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "cls-1",
			points: "9.519 18 14.019 18 14.019 13.5 9.519 13.5"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 5.019,
			y1: 3,
			x2: 1.269,
			y2: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 5.019,
			y1: 7.5,
			x2: 1.269,
			y2: 9
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 3.519,
			y1: 5.25,
			x2: .75,
			y2: 5.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-2",
			x1: 3.519,
			y1: 5.25,
			x2: .75,
			y2: 5.25
		})
	]
});
export default SvgGardeningSprinkleBottle;
